import { api } from "./api";
import { currentUser } from "./pb";
import type { Organization } from "./types";

let cached: Organization | null = null;
let inflight: Promise<Organization | null> | null = null;

/** Fetches (and caches) the current user's organization. Returns null if the
 * user has not yet joined/created an organization. */
export async function getOrganization(
  forceRefresh = false,
): Promise<Organization | null> {
  const orgId = currentUser()?.organization;
  if (!orgId) return null;
  if (!forceRefresh && cached?.ID === orgId) return cached;
  if (!inflight) {
    inflight = api
      .get<Organization>(`/tenancy/organizations/${orgId}`)
      .then((org) => {
        cached = org;
        return org;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function clearOrganizationCache(): void {
  cached = null;
}
